// @flow

import type { State } from "@store/reducers";
import type {
  AbsenceReason,
  AbsenceReasonsState,
} from "@modules/service/reducer/absence-reasons/types";
import type { ApprovableContainer } from "@modules/service/types";
import { removeNullAndUndefinedProps } from "@transformers/object";
import Ajv from "ajv";
import type { PaginationExtendedType, SortOrder } from "@types";
import { getPagination } from "@selectors";
import type { Settings } from "@modules/settings/types";

export const getAbsenceReasonContainer = (state: State): ?AbsenceReason =>
  state.service.absenceReasons.current;

// MODALS
export const getShowAddAbsenceReasonModal = (state: State): boolean =>
  state.service.absenceReasons.modals.showAddAbsenceReasonModal;

export const getShowEditAbsenceReasonModal = (state: State): boolean =>
  state.service.absenceReasons.modals.showEditModal;

export const getAbsenceReasonRevisionSchema = (state: State) => state.service.absenceReasons.schema;

// // CONFIG

export const absenceReasonsSelector = (state: State): AbsenceReasonsState =>
  state.service.absenceReasons;

// // DATA

export const getAbsenceReasonsList = (state: State) =>
  (absenceReasonsSelector(state).list || {}).content || [];

export const getAbsenceReasonsTotalElements = (state: State): number =>
  absenceReasonsSelector(state)?.list?.totalElements || 0;

export const getAbsenceReasonsPagination = (state: State): PaginationExtendedType =>
  getPagination(absenceReasonsSelector(state).list);

export const absenceReasonSchema = (state: State): ?Object => absenceReasonsSelector(state).schema;

export const selectAbsenceReasonsPage = (state: State): number | null =>
  ((absenceReasonsSelector(state).list || {}).pagination || {}).pageNumber;

export const getAbsenceReasonsFilterState = (state: State) => {
  return state.service.absenceReasons.filterState;
};

export const getAbsenceReasonsFilterType = (state: State) => {
  return state.service.absenceReasons.filterType;
};

export const getAbsenceReasonsLoading = (state: State): boolean => {
  return !!state.service.absenceReasons.isLoading;
};
